module.exports = __webpack_public_path__ + "img/upload_btn.85728361.png";